import store from '@/core/store'
import {actionTypes} from '@/core/constants'
import i18n from '@/i18n'

class BuscarLinguagemListener {
    async execute() {
        await store.dispatch(actionTypes.BUSCAR_LINGUAGEM)
        return new Promise((resolve) => {
            i18n.locale = store.state.linguagem
            resolve()
        })
    }
}

export default new BuscarLinguagemListener()
